import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { ExpandableHint } from '@/shared/ui/ExpandableHint'

/**
 * Qurilma nosozligining TEXNIK matni — yopiq holatda, belgisi bilan.
 *
 * <h2>⚠️ NEGA BU KOMPONENT BOR (BUG-033)</h2>
 * Tashqi tester «ERROR MESSAGE TUSHINARLI [emas]» deb yozgan: qurilma
 * bilan bog'lanib bo'lmaganda ekranda uzun, past darajali Java matni
 * turardi. Manba o'lchangan (`shared/devicegw`, boshqa muhandis
 * doirasida):
 *
 * <pre>
 * HikOperations   → "qurilmaga yetib bo'lmadi: " + e
 * IsupGatewayClient → "gateway'ga yetib bo'lmadi: " + e
 * </pre>
 *
 * <p>Java'da istisnoni satrga qo'shish uning TO'LIQ SINF NOMINI beradi,
 * ya'ni operator ekranda `java.net.SocketTimeoutException` va ISAPI
 * manzilini ko'rardi.
 *
 * <h2>⚠️ MATN O'CHIRILMAYDI — KO'CHIRILADI</h2>
 * Uni butunlay olib tashlash vasvasali edi va RAD ETILDI: aynan shu
 * qator nosozlikni topadigan yagona ip bo'lishi mumkin («ulanish rad
 * etildi» bilan «vaqt tugadi» butunlay boshqa ish talab qiladi).
 * Nuqson matnning BORLIGIDA emas, uning BIRINCHI O'RINDA turishida
 * edi — u tarjima qilingan, odam o'qiy oladigan xabarni bosib
 * ketardi.
 *
 * <p>Shuning uchun tartib ALMASHTIRILDI: birinchi o'rinda holat
 * bo'yicha tarjima qilingan tushuntirish, texnik qator esa shu
 * yerda — yopiq, belgilangan va istalgan payt ochiladigan holda
 * ({@code ExpandableHint} matnni QISQARTIRMAYDI, yashiradi).
 *
 * <h2>⚠️ `SafeErrorText` BU YO'LDA ISHLAMAYDI</h2>
 * Tozalagich faqat XATO javoblarida ({@code XsibResponse.error})
 * chaqiriladi. Qurilma tekshiruvi esa muvaffaqiyatli javob — HTTP 200,
 * ichida «yetib bo'lmadi» degan NATIJA. Ya'ni bu matn hech qanday
 * tozalagichdan o'tmaydi va o'tishi ham kerak emas: bu yerda u
 * xatoning O'ZI emas, diagnostika ma'lumoti.
 */
export function TechnicalDetail({ text }: { text: string | null | undefined }) {
  const { t } = useTranslation()

  if (!text) return null

  return (
    <div style={{ marginTop: 8 }}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {t('attendance.technicalDetail')}
      </Typography.Text>
      {/* ⚠️ Yopiq holatda BIR qator: bu yordamchi izoh emas, shovqin —
          u faqat so'ralganda ochilishi kerak. */}
      <ExpandableHint text={text} lines={1} fontSize={12} />
    </div>
  )
}
